export const ZipPattern = /^[0-9]{4,5}$/;
export const PhonePattern = /^[+49|0]([1-9]\d{8,15})$/;

export const validatePattern = (value: string, pattern: RegExp): boolean => {
  const regex = new RegExp(pattern);
  return regex.test(value);
};
